import { lazy } from "react"
import type { FC, LazyExoticComponent, ReactElement } from "react"

import { ETypographyAlignment, ETypographySize, Loadable, RootLoaderFallback, Typography } from "@/3514/components"
import { type TDiagnosticSummaryEntityProps, diagnosticSummaryEntityLoader } from "@/3514/entities/diagnostic-summary"
import { EUserRole } from "@/3514/types"
import { type IUseTranslation, useTranslation } from "@/hooks"

import classes from "./coach.group-participant.styles"
import { type TCoachGroupParticipantSharedTabProps as TSharedProps } from "./coach.group-participant.ui.types"

const LazyDiagnosticsEntity: LazyExoticComponent<FC<TDiagnosticSummaryEntityProps>> =
    lazy(diagnosticSummaryEntityLoader)

type _TProps = TSharedProps & { isParticipantLoading: boolean; isDiagnosticEnabled: boolean }
const CoachGroupParticipantDiagnosticTab: FC<_TProps> = ({
    participantId,
    isParticipantLoading,
    isDiagnosticEnabled
}: _TProps): ReactElement => {
    const { t }: IUseTranslation = useTranslation()

    return (
        <Loadable<TDiagnosticSummaryEntityProps>
            isLoading={isParticipantLoading}
            loadingFallback={<RootLoaderFallback top="25%" xsTop="45%" />}
            component={
                isDiagnosticEnabled ? (
                    LazyDiagnosticsEntity
                ) : (
                    <div className={classes.diagnosticTab.container()}>
                        <Typography
                            text={t("coachSide.participantPages.diagnostic.na")}
                            className={classes.diagnosticTab.emptyHint()}
                            isPretty
                            size={ETypographySize.Small}
                            alignment={ETypographyAlignment.Left}
                        />
                    </div>
                )
            }
            componentProps={{
                participantId,
                mode: EUserRole.Coach,
                wrapperClassName: classes.diagnosticTab.container()
            }}
        />
    )
}

CoachGroupParticipantDiagnosticTab.displayName = "CoachGroupParticipantDiagnosticTab"

export default CoachGroupParticipantDiagnosticTab
